import React from "react";
import { formatInUserTimezone } from "../../../utils/timezone";

function SRMyNextActions({ items, loading, error, onOpenLead, onRefresh, onViewAll }) {
  if (error) {
    return (
      <div className="dashboard-card-v2">
        <div className="dashboard-card-v2-header">
          <i className="fas fa-bolt" />
          <span>My Next Actions</span>
        </div>
        <div className="dashboard-card-v2-body">
          <div className="dashboard-error">
            <i className="fas fa-exclamation-circle" /> {error}
            <button type="button" className="btn btn-secondary btn-sm" onClick={onRefresh}>
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-card-v2">
      <div className="dashboard-card-v2-header">
        <i className="fas fa-bolt" />
        <span>My Next Actions</span>
        <span className="dashboard-card-v2-count">{items.length}</span>
      </div>
      <div className="dashboard-card-v2-body">
        {loading ? (
          <div className="dashboard-skeleton-list">
            {Array.from({ length: 4 }).map((_, i) => (
              <div key={i} className="dashboard-skeleton-row" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="dashboard-empty">
            <i className="fas fa-check-circle" />
            <p>All caught up — no pending actions.</p>
          </div>
        ) : (
          <div className="sr-next-actions-list">
            {items.map((item) => {
              const overdue = item.status === "Overdue";
              return (
                <button
                  type="button"
                  key={item.next_activity_id}
                  className={`sr-next-action-item ${overdue ? "is-overdue" : ""}`}
                  onClick={() => onOpenLead(item.lead_id)}
                >
                  <div className="sr-next-action-dot" />
                  <div className="sr-next-action-content">
                    <div className="sr-next-action-line-1">
                      <strong>{item.activity_type}</strong>
                      <span className="sr-next-action-company">
                        {item.lead_company || "Lead"}
                      </span>
                    </div>
                    <div className="sr-next-action-line-2">
                      {formatInUserTimezone(item.planned_date)}
                      {overdue && <span className="sr-next-action-badge">Overdue</span>}
                    </div>
                  </div>
                  <i className="fas fa-chevron-right" />
                </button>
              );
            })}
          </div>
        )}
      </div>
      {onViewAll && !loading && (
        <button type="button" className="dashboard-card-v2-footer-link" onClick={onViewAll}>
          View all pending actions
          <i className="fas fa-arrow-right" />
        </button>
      )}
    </div>
  );
}

export default SRMyNextActions;